'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import { classNameFix, getPassThroughProps, getValue } from './utils';
import { jsx as _jsx } from "react/jsx-runtime";
export default class FormattedHTMLMessage extends Component {
  render() {
    const {
      useGap,
      message,
      options
    } = this.props;
    const props = classNameFix(getPassThroughProps(this.props));

    // must use dangerouslySetInnerHTML prop to display embedded HTML
    return /*#__PURE__*/_jsx("i18n-string", Object.assign({}, props, {
      dangerouslySetInnerHTML: {
        __html: getValue({
          useGap,
          message,
          options
        })
      }
    }));
  }
}
FormattedHTMLMessage.displayName = 'FormattedHTMLMessage';
FormattedHTMLMessage.propTypes = {
  message: PropTypes.string.isRequired,
  options: PropTypes.object,
  useGap: PropTypes.bool
};
FormattedHTMLMessage.isI18nElement = true;
FormattedHTMLMessage.defaultProps = {
  options: {},
  useGap: false
};